// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jxi3I","inner":"styles_inner__3yR2B","right":"styles_right__3xp63","close":"styles_close__2sGdq","footer":"styles_footer__1H1Zy"};